/**
 * Defines custom event names used throughout the application.
 *
 * @property authenticationRequired - Event triggered when authentication is required.
 * @property logOffEvent - Event triggered when a logoff action occurs.
 */
export const customEvents = {
  authenticationRequired: 'authentication-required',
  forbidden: 'forbidden',
  logOffEvent: 'logoff',
} as const;
